<template>
  <card-component class="has-table has-mobile-sort-spaced" title="Nivel de Doma" subtitle="Caballos por nivel de doma">
    <div slot="content">
      <div class="indicator-container indicator" @click="goHorseView('high')">
        <div class="columns is-mobile">
          <div class="column">
            <div><span class="level-number">{{highLevel}}</span><span class="level-label">Caballos.</span></div>
            <div class="level-text">Nivel Alto</div>
          </div>
          <div class="column is-narrow"><b-tag type="is-success" size="is-large">A</b-tag></div>
        </div>
      </div>
      <div class="indicator-container indicator" @click="goHorseView('medium')">
        <div class="columns is-mobile">
          <div class="column">
            <div><span class="level-number">{{mediumLevel}}</span><span class="level-label">Caballos.</span></div>
            <div class="level-text">Nivel Medio</div>
          </div>
          <div class="column is-narrow"><b-tag type="is-warning" size="is-large">M</b-tag></div>
        </div>
      </div>
      <div class="indicator-container indicator" @click="goHorseView('low')">
        <div class="columns is-mobile">
          <div class="column">
            <div><span class="level-number">{{lowLevel}}</span><span class="level-label">Caballos.</span></div>
            <div class="level-text">Nivel Bajo</div>
          </div>
          <div class="column is-narrow"><b-tag type="is-danger" size="is-large">B</b-tag></div>
        </div>
      </div>
      <div class="indicator-container indicator" @click="goHorseView('no-level')">
        <div class="columns is-mobile">
          <div class="column">
            <div><span class="level-number">{{noLevel}}</span><span class="level-label">Caballos.</span></div>
            <div class="level-text">Sin Nivel</div>
          </div>
          <div class="column is-narrow"><b-tag type="is-ligth" size="is-large">S</b-tag></div>
        </div>
      </div>
    </div>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import TenantService from '@/services/TenantService'

export default {
  components: {
    CardComponent
  },
  created () {
    this.getLevelSummary()
  },
  data () {
    return {
      lowLevel: 0,
      mediumLevel: 0,
      highLevel: 0,
      noLevel: 0
    }
  },
  methods: {
    async getLevelSummary () {
      let response = await TenantService.getLevelSummary()
      let levelSummary = response.data
      this.highLevel = levelSummary.find(x => x.level === 'high').horses
      this.mediumLevel = levelSummary.find(x => x.level === 'medium').horses
      this.lowLevel = levelSummary.find(x => x.level === 'low').horses
      this.noLevel = levelSummary.find(x => x.level === 'no level').horses
    },
    goHorseView (level) {
      if (level) {
        this.router.push({ name: 'horses.list', query: { level_status: level } })
      }
    }
  }

}
</script>

<style >
  hr.divider{
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .level-number{
    font-size: 2rem;
    font-weight: 800;
    line-height: 0.8;
  }

  .level-label{
    font-size: 0.8rem;
    font-weight: 800;
    line-height: 0.8;
    margin-left: 5px;
  }

  .level-text{
    font-size: 1rem;
    font-weight: 400;
    line-height: 1;
  }

  .indicator-container{
    padding: 20px 20px;
    border-bottom: 1px solid #E0E0E0;
  }

  .indicator-container.indicator:hover {
    background-color: #E0E0E0;
    cursor: pointer;
  }

  .indicator-container:last-child{
    border-bottom: 0px !important;
  }
</style>
